export const Navs = [
  {
    text: 'Home',
    to: '/',
  },
  {
    text: 'About',
    to: '/about',
  },
  {
    text: 'For sale',
    to: '/for-sale'
  },
  {
    text: 'Rentals',
    to: '/golf-car-rentals'
  },
  {
    text: 'Services',
    to: '/services',
  },
  {
    text: 'Contact',
    to: '/contact',
  },
]

export const ServiceNav = [
  {
    text: 'Small Engine Repair',
    to: '/small-engine-repair'
  },
  {
    text: 'Welding Services',
    to: '/welding-services'
  },
  {
    text: 'Remote Services',
    to: '/remote-services'
  },
  {
    text: 'Golf Car Rentals',
    to: '/golf-car-rentals'
  },
]

export const menuConfig = {
  bmBurgerButton: {
    position: 'fixed',
    width: '40px',
    height: '40px',
    left: '0px',
    top: '0px',
  },
  bmBurgerBars: {
    background: '#718096',
  },
  bmBurgerBarsHover: {
    background: '#a90000',
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
  },
  bmMenu: {
    background: '#373a47',
    padding: '2.5em 1.5em 0',
    fontSize: '1.15em',
  },
  bmMorphShape: {
    fill: '#373a47',
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: '0.8em',
  },
  bmItem: {
    display: 'inline-block',
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
  },
}